/**
 * Pure helpers for My Lists UI copy. Kept free of React so they are easy to test.
 */

const TIER_LABELS = { bronze: 'Bronze', silver: 'Silver', gold: 'Gold', legendary: 'Legendary' };

/** "Verify & Earn" → "Upgrade to Silver" → "Upgrade to Gold" → "Upgrade to Legendary" → "Legendary ✓" */
export function getListItemCta(progression) {
    if (progression.isComplete) return 'Legendary ✓';
    if (!progression.currentTier) return 'Verify & Earn';
    if (progression.nextTier === 'silver') return 'Upgrade to Silver';
    if (progression.nextTier === 'gold') return 'Upgrade to Gold';
    if (progression.nextTier === 'legendary') return 'Upgrade to Legendary';
    return progression.ctaLabel;
}

/** "Not verified" | "Bronze" | "Silver" | "Gold" | "Legendary ✓" */
export function getListItemStatusLabel(progression) {
    if (!progression.currentTier) return 'Not verified';
    const label = TIER_LABELS[progression.currentTier] ?? progression.currentTier;
    return progression.isComplete ? `${label} ✓` : label;
}

/** "8 titles · 3 verified" for a list summary */
export function formatListMeta(list) {
    const count = list.itemCount ?? 0;
    const titles = `${count} title${count === 1 ? '' : 's'}`;
    return count > 0 ? `${titles} · ${list.verifiedCount ?? 0} verified` : titles;
}

/** "Loki — Season 1" | "Loki — Entire Series" | "Heat" */
export function getSeasonAwareTitle(target) {
    if (!target?.title) return '';
    if (target.mediaType !== 'tv') return target.title;
    return target.seasonNumber != null ? `${target.title} — Season ${target.seasonNumber}` : `${target.title} — Entire Series`;
}

/** Route for a list item: season-specific TV items open the season page. */
export function getListItemHref(item) {
    return item.mediaType === 'tv' && item.seasonNumber != null
        ? `/movie/tv/${item.mediaId}/season/${item.seasonNumber}`
        : `/movie/${item.mediaType}/${item.mediaId}`;
}

export function moveWithinArray(items, fromIndex, toIndex) {
    const next = [...items];
    const [moved] = next.splice(fromIndex, 1);
    next.splice(toIndex, 0, moved);
    return next;
}
